import React from 'react';

import * as S from './goSafeCard.styles';

const GoSafeCard: React.FC<{
  title: string;
  titleColor: string;
  message: string;
  messageColor: string;
  ContainerWrapper: Element;
  ctaUrl?: string;
  footerText?: string;
  footerColor?: string;
  icon?: string;
  backgroundColor?: string;
}> = ({
  title,
  backgroundColor,
  titleColor,
  message,
  messageColor,
  footerText,
  footerColor,
  icon,
  ctaUrl,
  ContainerWrapper,
}) => {
  const gethtml = () => {
    return (
      <S.GoSafeSearchBlockContainerWrap backgroundColor={backgroundColor}>
        {(icon && <S.GlobeAlertIconWrap src={icon} />) || null}
        <S.GoSafeSearchBlockTextWrap>
          <S.GoSafeCardHeader color={titleColor}>{title}</S.GoSafeCardHeader>
          <S.GoSafeCasesInfoText color={messageColor}>
            {message}
            {!!ctaUrl && (
              <S.GoSafeLearnMoreBtn href={ctaUrl} target="_blank" color={footerColor}>
                {footerText || 'Know More'}
              </S.GoSafeLearnMoreBtn>
            )}
          </S.GoSafeCasesInfoText>
        </S.GoSafeSearchBlockTextWrap>
      </S.GoSafeSearchBlockContainerWrap>
    );
  };

  if (ContainerWrapper) return <ContainerWrapper>{gethtml()}</ContainerWrapper>;
  else return gethtml();
};

export default GoSafeCard;
